import { Action } from "redux-actions";
import { PUSH_BOOKS, SET_BOOK_PROPERTIES, SetBookPropertiesPayload, DELETE_BOOKS, REMOVE_HISTORY_ITEM, RemoveHistoryPayload, SET_BOOKS, EDIT_HISTORY_ITEM, EditHistoryItemPayload } from "./actions";
import { LibraryCard } from "../../types/LibraryCard";
import { parseISO } from "date-fns";

export interface CalendarState {
	[bookId: number]: LibraryCard;
}

export const calendarReducer = (state: CalendarState = {}, action: Action<LibraryCard[] | SetBookPropertiesPayload | number | RemoveHistoryPayload>) => {
	if (action.type === SET_BOOKS) {
		const state: CalendarState = {};

		const cards = action.payload as LibraryCard[];

		cards.forEach(card => {
			state[card.eId] = card;
		});

		return state;
	}
	else if (action.type === PUSH_BOOKS) {
		const newState = {
			...state
		};

		const cards = action.payload as LibraryCard[];

		cards.forEach(card => {
			newState[card.eId] = card;
		});

		return newState;
	}
	else if (action.type === SET_BOOK_PROPERTIES) {
		const payload = action.payload as SetBookPropertiesPayload;

		return {
			...state,
			[payload.cardId]: {
				...state[payload.cardId],
				cardType: payload.cardType || state[payload.cardId].cardType,
				properties: {
					...state[payload.cardId].properties,
					...payload.properties
				}
			}
		}
	}
	else if (action.type === DELETE_BOOKS) {
		const payload = action.payload as number;

		return {
			...state,
			[payload]: null
		}
	}
	else if (action.type === REMOVE_HISTORY_ITEM) {
		const payload = action.payload as RemoveHistoryPayload;

		return {
			...state,
			[payload.cardId]: {
				...state[payload.cardId],
				history: state[payload.cardId].history.filter(history => history.id !== payload.historyId)
			}
		}
	}
	else if (action.type === EDIT_HISTORY_ITEM) {
		const payload = action.payload as EditHistoryItemPayload;

		return {
			...state,
			[payload.cardId]: {
				...state[payload.cardId],
				history: state[payload.cardId].history.map(
					(history) => {
						return {
							...history,
							startDate: history.id === payload.historyId ? parseISO(payload.start) : history.startDate,
							finishDate: history.id === payload.historyId ? parseISO(payload.end): history.finishDate
						}
					}
				),
			},
		};
	}
		
	return state;
}
